<ng-container *transloco="let t">
  <div
    id="migration-notification-page"
    class="min-h-screen w-full bg-ld-neutral-700 flex items-center justify-center p-4"
  >
    <div
      id="migration-notification-card"
      class="bg-white rounded-2xl shadow-card w-full max-w-[640px] min-w-0 p-8 sm:px-12 sm:py-10"
    >
      <div id="migration-notification-header" class="flex flex-col items-center gap-3 mb-8">
        <img id="migration-notification-logo" [src]="logoUrl()" [alt]="partnerDisplayName()" class="h-14 w-auto mb-2" />
        <h1 id="migration-notification-title" class="text-section-heading text-ld-neutral-700 text-center m-0">
          {{ t('authMigrationNotificationTitle') }}
        </h1>
        <p
          id="migration-notification-description"
          class="font-dm text-sm leading-5 text-ld-neutral-500 text-center m-0 mt-1"
        >
          {{ t('authMigrationNotificationDescription') }}
        </p>
      </div>

      <div id="migration-notification-actions" class="flex flex-col gap-6">
        <button
          type="button"
          id="migration-notification-continue-button"
          class="w-full h-12 bg-ld-primary text-white border-0 font-dm font-semibold text-base tracking-[0.1px] uppercase cursor-pointer rounded-[22px] transition-all hover:bg-ld-primary-hover active:scale-[0.98] disabled:bg-ld-primary disabled:cursor-wait focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 flex items-center justify-center gap-2"
          [disabled]="isLoading()"
          (click)="onContinue()"
        >
          @if (isLoading()) {
            <mat-spinner
              diameter="20"
              id="migration-notification-spinner"
              class="text-white! [&_circle]:stroke-white!"
            ></mat-spinner>
            <span>{{ t('commonLabelsLoading') }}</span>
          } @else {
            <span>{{ t('commonButtonsContinue') }}</span>
          }
        </button>
      </div>
    </div>
  </div>
</ng-container>
